var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCompartilhar01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1463",
    d: "M28.2,23.2c-2,0-3.8,0.9-4.9,2.5l-9.6-4.9c0.4-1.3,0.3-2.7-0.2-4l10.1-6.1c2.2,2.6,6.1,2.9,8.6,0.7 s2.9-6.1,0.7-8.6c-2.2-2.6-6.1-2.9-8.6-0.7c-2,1.7-2.7,4.4-1.7,6.9L12.4,15c-2.2-2.6-6.1-2.8-8.7-0.6c-2.6,2.2-2.8,6.1-0.6,8.7 c2.2,2.6,6.1,2.8,8.7,0.6c0.4-0.3,0.7-0.7,1-1l9.6,4.9c-1,3.2,0.8,6.7,4,7.7s6.7-0.8,7.7-4s-0.8-6.7-4-7.7 C29.5,23.3,28.9,23.2,28.2,23.2L28.2,23.2z M28.2,2.6c2.3,0,4.1,1.8,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1 c0,0,0,0,0,0C24.1,4.4,26,2.6,28.2,2.6z M7.8,23.1c-2.3,0-4.1-1.8-4.1-4.1s1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1l0,0 C11.9,21.3,10,23.1,7.8,23.1z M28.2,33.4c-2.3,0-4.1-1.8-4.1-4.1s1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1l0,0 C32.3,31.6,30.5,33.4,28.2,33.4L28.2,33.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCompartilhar01);
export default __webpack_public_path__ + "static/media/ico-compartilhar-01.a98d7e5d5cb072e1b5f58f4adeaa52f3.svg";
export { ForwardRef as ReactComponent };